import { memo, useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api_jobs_public } from '../../../constants/apiRoutes';
import http from '../../../utility/http';
import { useTranslations } from '../../../utility/useTranslations';
import { APP_PAGES } from '../../../constants/pages';
import { showErrorMessage, showSuccessMessage } from '../../../utility/uiUtils';
import ApplyJobForm from './applyJobForm';

const JOB_UNAVAILABLE_PATH = '/job-unavailable';

const ApplyJobPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const translations = useTranslations(APP_PAGES.APPLY_JOB);

  const [job, setJob] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [rateLimitErrorMessage, setRateLimitErrorMessage] = useState('');

  const getJobData = useCallback(async () => {
    try {
      const { data } = await http.get(api_jobs_public(token));
      setJob(data);
    } catch (error) {
      if (error?.response?.status === 404) {
        navigate(JOB_UNAVAILABLE_PATH, { replace: true });
      }
    } finally {
      setIsLoading(false);
    }
  }, [navigate, token]);

  useEffect(() => {
    getJobData();
  }, [getJobData]);

  return (
    !isLoading && (
      <ApplyJobForm
        translations={translations}
        jobTitle={job?.title}
        token={token}
        navigate={navigate}
        showErrorMessage={showErrorMessage}
        showSuccessMessage={showSuccessMessage}
        rateLimitErrorMessage={rateLimitErrorMessage}
        setRateLimitErrorMessage={setRateLimitErrorMessage}
      />
    )
  );
};

export default memo(ApplyJobPage);
